import { siteInfo } from '@/mocks/chiguaData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-white font-heading whitespace-nowrap">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              更新每日新鲜吃瓜内容，涵盖91今日吃瓜、吃瓜日报和每日热门瓜，提供今日新鲜瓜汇总，让吃瓜群众第一时间掌握最新动态。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '实时快讯', href: '#updates' },
                { label: '热门瓜文', href: '#cards' },
                { label: '吃瓜排行', href: '#ranking' },
                { label: '吃瓜问答', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">热门分类</h3>
            <div className="flex flex-col gap-2.5">
              {['娱乐圈八卦', '影视综评', '网红达人', '商业吃瓜'].map((cat) => (
                <span key={cat} className="text-sm text-background-400 whitespace-nowrap">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-background-400">
              更多合作伙伴即将入驻，敬请期待
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer">
              联系我们
            </a>
            <span className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer">
              隐私政策
            </span>
            <span className="text-xs text-background-400 hover:text-white transition-colors cursor-pointer">
              用户协议
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}